import script from "./TasksPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TasksPage.vue?vue&type=script&setup=true&lang=js"

import "./TasksPage.vue?vue&type=style&index=0&id=54b53452&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54b53452"]])

export default __exports__